import { flatMap } from 'lodash';
import {
    SignUpError,
    SIGNUP_EMAIL_ERRORS,
    SIGNUP_USERNAME_ERRORS,
    SIGNUP_PASSWORD_ERRORS,
} from '../signUp/signUp.types';

const ERROR_CONFIG = {
    email: new Set(SIGNUP_EMAIL_ERRORS),
    username: new Set(SIGNUP_USERNAME_ERRORS),
    password: new Set(SIGNUP_PASSWORD_ERRORS),
} as const;

type ErrorConfig = typeof ERROR_CONFIG;

const allKnownErrorsSet = new Set(flatMap(Object.values(ERROR_CONFIG), (set) => Array.from(set)));

type KnownErrors = {
    [K in keyof ErrorConfig]: ErrorConfig[K] extends Set<infer T> ? T[] : never[];
};

export type AllErrors = KnownErrors & {
    unknown: string[];
};

export type Result = Partial<AllErrors>;

export const formatSignupErrors = (errors: SignUpError[]): Result => {
    const allErrors = errors.reduce<AllErrors>(
        (acc, error) => {
            if (!allKnownErrorsSet.has(error)) {
                acc.unknown.push(error);
            }

            Object.entries(ERROR_CONFIG).forEach(([field, errorSet]) => {
                if ((errorSet as Set<SignUpError>).has(error) && acc[field]) {
                    acc[field].push(error);
                }
            });

            return acc;
        },
        {
            email: [],
            username: [],
            password: [],
            unknown: [],
        }
    );

    return Object.fromEntries(Object.entries(allErrors).filter(([_key, value]) => value.length > 0));
};
